import React from 'react'
import { BsRocketTakeoff } from 'react-icons/bs'
import { CgClapperBoard } from 'react-icons/cg'
import { FaRegLightbulb } from 'react-icons/fa'
import { TbFocus2 } from 'react-icons/tb'
import { SlGraduation } from 'react-icons/sl'

const Uses = () => {
    return (
        <div className='uses-main'>
            <h1 className='section-heading'>Why use Codie?</h1>
            <div className='uses-container'>
                <div className='uses-item'>
                    <CgClapperBoard />
                    <h3>Accessible</h3>
                    <p>Codie comes as a chrome extension, meaning there's no need to switch tabs when you're stuck at a problem</p>
                </div>
                <div className='uses-item'>
                    <FaRegLightbulb />
                    <h3>Smart</h3>
                    <p>Codie can read and understand the question you are solving. No more copy pasting stuff</p>
                </div>
                <div className='uses-item'>
                    <BsRocketTakeoff />
                    <h3>Efficient</h3>
                    <p>Codie comes with well engineered prompts that you can use with a click of a button.</p>
                </div>
                <div className='uses-item'>
                    <TbFocus2 />
                    <h3>Focus</h3>
                    <p>Using Codie, prepare for interviews faster without any distraction</p>
                </div>
                <div className='uses-item'>
                    <SlGraduation />
                    <h3>Knowledge</h3>
                    <p>Learn about different ways to solve each problem</p>
                </div>
            </div>
        </div>
    )
}

export default Uses